import styled from 'styled-components';
import { Typography } from 'modules/Typography';
import { themeGet } from 'modules/tetrisTheme';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
`;
export const Title = styled(Typography) `
  margin-left: ${themeGet('spacing.md')};
`;
